import { MenuItem, TextField } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { RadioReceiver } from "src/store/api/generatedApi";
import { useChannelName } from "./useChannelName";

type Props = Readonly<{
  receivers: readonly RadioReceiver[];
  selectedReceiverId: number | null;
  onSelect: (receiverId: number) => void;
}>;

/** Picks which of a device's radio channels to play; hidden when there is one. */
export const RadioChannelSelect = ({
  receivers,
  selectedReceiverId,
  onSelect,
}: Props) => {
  const { t } = useTenantTranslation();
  const channelName = useChannelName();
  if (receivers.length < 2) return null;

  return (
    <TextField
      select
      size="small"
      label={t("radioChannel")}
      value={selectedReceiverId ?? ""}
      onChange={(event) => {
        onSelect(Number(event.target.value));
      }}
      sx={{ minWidth: 160 }}
    >
      {receivers.map((receiver) => (
        <MenuItem key={receiver.id} value={receiver.id}>
          {channelName(receiver)}
        </MenuItem>
      ))}
    </TextField>
  );
};
